
import $ from 'jquery';

const table = {

    init: function ()  {
        const tables = document.querySelectorAll('.table-block');

        if (!tables) {
            return;
        }

        tables.forEach(table => {
            this.handleTableSlide(table);
        })
    },
    handleTableSlide: function(table) {
        const tableRows = table.querySelectorAll('.table__row--content');
        const tableRowsCount = tableRows.length;
        const visibleCount = table.getAttribute('data-rows');
        const button = table.querySelector('.table__more-button');
        if (tableRowsCount > visibleCount) {
            tableRows.forEach((el, i)=> {

                if (i > visibleCount - 1) {
                    $(el).slideUp();
                }
                if (i === visibleCount - 1 ) {
                    el.classList.add('last');
                }
            })
            let slideDown = false;
            button.addEventListener('click', (e) => {
                e.preventDefault();
                slideDown = !slideDown;
                tableRows.forEach((el, i)=> {

                    if (i > visibleCount - 1) {
                        $(el).slideToggle();
                    }
                    if (i === visibleCount - 1 ) {
                        el.classList.toggle('last');
                    }
                });
                if (slideDown) {
                    button.textContent = 'Pokaż mniej'
                } else {
                    button.textContent = 'Pokaż więcej'
                }

            });
        } else {
            button.style.display = 'none';
            button.closest('.button-row').style.marginTop = 0;
        }
    }


}

export default table;